const toStatusNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const getSaleStatus = ({ status, amount, isExpired } = {}) => {
  const statusNumber = toStatusNumber(status);
  const remainingAmount = Number(amount || 0);

  if (isExpired) {
    return { text: "Hết hạn", variant: "secondary" };
  }

  switch (statusNumber) {
    case 2:
      return { text: "Ngưng bán", variant: "danger" };
    case 3:
      return { text: "Đã có KQ", variant: "primary" };
    case 4:
    case 5:
      return { text: "Đã trả thưởng", variant: "success" };
    default:
      break;
  }

  if (remainingAmount <= 0) {
    return { text: "Hết vé", variant: "warning" };
  }

  return { text: "Đang bán", variant: "success" };
};

export const getReturnStatus = ({ returnedAmount, inputAmount } = {}) => {
  const returned = Number(returnedAmount || 0);

  if (returned === 0) {
    return { text: "Chưa hoàn", variant: "success", color: "text-success" };
  }

  if (returned >= Number(inputAmount || 0)) {
    return { text: "Hoàn hết", variant: "danger", color: "text-danger" };
  }

  return { text: "Hoàn 1 phần", variant: "warning", color: "text-warning" };
};

